// Viewer-side twin of the capture signals in the proposal reader (api/src/tracker.client.js):
// keyboard focus starts on the viewer, so shortcuts pressed before clicking the proposal land here.
export interface CaptureSignal {
  type: 'printscreen' | 'screenshot' | 'print' | 'copy';
  confidence: 'alta' | 'media' | 'info';
  via?: string;
}

export const watchCaptures = (emit: (s: CaptureSignal) => void): (() => void) => {
  const last: Record<string, number> = {};
  let combo: { at: number; other: boolean } | null = null;
  const capture = (s: CaptureSignal) => {
    const now = Date.now();
    if (last[s.type] && now - last[s.type] < 1500) return;
    last[s.type] = now;
    emit(s);
  };
  const isMod = (k: string) => ['Meta', 'OS', 'Shift', 'Control', 'Alt'].includes(k);
  const down = (e: KeyboardEvent) => {
    const k = e.key || '';
    if (k === 'PrintScreen') capture({ type: 'printscreen', confidence: 'alta' });
    else if ((e.ctrlKey || e.metaKey) && !e.shiftKey && k.toLowerCase() === 'p') capture({ type: 'print', confidence: 'alta' });
    else if (e.metaKey && e.shiftKey && /^[3456]$/.test(k)) capture({ type: 'screenshot', confidence: 'alta', via: 'atalho' });
    else if (e.metaKey && e.shiftKey && k.toLowerCase() === 's') capture({ type: 'screenshot', confidence: 'media', via: 'atalho' });
    if (isMod(k)) {
      if (e.metaKey && e.shiftKey && !combo) combo = { at: Date.now(), other: false };
    } else if (combo) combo.other = true;
  };
  const up = (e: KeyboardEvent) => {
    const k = e.key || '';
    if (k === 'PrintScreen') capture({ type: 'printscreen', confidence: 'alta' });
    if (combo && ['Meta', 'OS', 'Shift'].includes(k)) {
      if (!combo.other && Date.now() - combo.at < 5000) capture({ type: 'screenshot', confidence: 'media', via: 'atalho' });
      combo = null;
    }
  };
  const blur = () => {
    if (combo && !combo.other && Date.now() - combo.at < 3000) capture({ type: 'screenshot', confidence: 'media', via: 'atalho' });
    combo = null;
  };
  const print = () => capture({ type: 'print', confidence: 'alta' });
  window.addEventListener('keydown', down, true);
  window.addEventListener('keyup', up, true);
  window.addEventListener('blur', blur);
  window.addEventListener('beforeprint', print);
  return () => {
    window.removeEventListener('keydown', down, true);
    window.removeEventListener('keyup', up, true);
    window.removeEventListener('blur', blur);
    window.removeEventListener('beforeprint', print);
  };
};
